module.exports = __webpack_public_path__ + "img/chicken-stew.68c2b30e.jpg";